import { render, staticRenderFns } from "./ModifyExtra.vue?vue&type=template&id=4ffee4a0"
import script from "./ModifyExtra.vue?vue&type=script&lang=js"
export * from "./ModifyExtra.vue?vue&type=script&lang=js"
import style0 from "./ModifyExtra.vue?vue&type=style&index=0&id=4ffee4a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports